export default __webpack_public_path__ + "static/media/AGRO_CANAL.ab2a8ea0.png";